import Layout from "@/components/Layout";
import DualPathHero from "@/components/conversion/DualPathHero";
import QuizTeaser from "@/components/conversion/QuizTeaser";
import TrustIndicators from "@/components/TrustIndicators";
import ServiceCards from "@/components/ServiceCards";
import ReferralCTA from "@/components/ReferralCTA";
import SEO from "@/components/SEO";
import SchemaMarkup from "@/components/SchemaMarkup";
import LoanPreQualifier from "@/components/calculators/LoanPreQualifier";

const Index = () => {
  return (
    <Layout>
      <SEO
        title="Atralend - B2B & Private Lending Marketplace | Commercial Real Estate Financing"
        description="Canada's premier B2B lending marketplace. Fund commercial properties in 48 hours or deploy capital with 8-12% target yields. Connect with opportunities that matter."
        canonical="https://atralend.com/"
      />
      <SchemaMarkup />
      <DualPathHero />
      <QuizTeaser />
      
      {/* Loan Pre-Qualifier Section */}
      <section className="py-16 md:py-24 bg-gradient-to-b from-background to-muted/30">
        <div className="container mx-auto px-4">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Find Your Perfect Financing Solution
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Answer a few quick questions and we'll match you with the best lending options for your situation.
            </p>
          </div>
          <LoanPreQualifier />
        </div>
      </section>
      
      <TrustIndicators />
      <ServiceCards />
      <ReferralCTA />
    </Layout>
  );
};

export default Index;